//   import "./App.css";
//   import {
//     Routes,
//     Route
//   } from 'react-router-dom';
//   import Homepage from "./Pages/HomePage";
// import Chatpage from "./Pages/ChatPage";

//   function App() {
//     return (
//       <div className="App">
//         <div>
//           <Routes>
//             <Route exact path="/" element={<Homepage />} />
//             <Route exact path="/chats" element={<Chatpage />} />
//           </Routes>
//         </div>
//         <div className="name">
//           <p>&copy;Daksh Mehta</p>
//         </div>
//       </div>
//     );
//   }

//   export default App;


import "./App.css";
import { Routes, Route } from "react-router-dom";
import Homepage from "./Pages/HomePage";
import Chatpage from "./Pages/ChatPage";
import { ChatState } from "./Context/ChatProvider";

function App() {
  const { user } = ChatState();

  return (
    <div className="App">
      <div>
        <Routes>
          <Route exact path="/" element={<Homepage />} />
          <Route exact path="/chats" element={<Chatpage />} />
        </Routes>
      </div>
      {!user && ( // Conditionally render the footer based on user state
        <div className="name">
          <p>&copy;Daksh Mehta</p>
        </div>
      )}
    </div>
  );
}

export default App;
